// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".quote-clamped[data-v-584d4235]{-webkit-box-orient:vertical;-webkit-line-clamp:8;display:-webkit-box;overflow:hidden}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
